import { ToastSkin } from './types';

export const skinMessages: { [skin in keyof typeof ToastSkin]: string } = {
  [ToastSkin.success]: '24 photos were uploaded successfully.',
  [ToastSkin.error]: 'These files exceed the upload limit.',
  [ToastSkin.status]: 'Uploading...',
  [ToastSkin.preview]:
    'This is how other members of the community see your profile.',
};
